export enum ChurchEvents {
  Mass,
  Confession,
}
